import { useEffect, useState } from 'react';

export enum Direction {
  BOTTOM = 'BOTTOM',
  TOP = 'TOP',
}

const useScrollDirection = (ref: any) => {
  const [height, setStartHeight] = useState(0);
  const [direction, setDirection] = useState('');

  const startScroll = () => {
    setStartHeight(ref.current.scrollTop);
  };

  const endScroll = () => {
    if (height < ref.current.scrollTop) {
      setDirection(Direction.TOP);
    }
    if (height > ref.current.scrollTop) {
      setDirection(Direction.BOTTOM);
    }
    setStartHeight(ref.current.scrollTop);
  };

  useEffect(() => {
    window.addEventListener('touchstart', startScroll);
    window.addEventListener('touchend', endScroll);
    return () => {
      window.removeEventListener('touchstart', startScroll);
      window.removeEventListener('touchend', endScroll);
    };
  }, [ref, height]);

  return {
    direction,
  };
};

export default useScrollDirection;
